// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__fPMee","link":"style_link__J6R5f","image":"style_image__eU_jf","playIcon":"style_playIcon__WHYdN"};